export default __webpack_public_path__ + "static/media/ic_hungama.43a56e60.png";